<header class="c-modal-core__header">
    <div class="c-modal-core__header-logo"></div>
</header>

<div class="o-box" [class.o-box--thin]="thin">
    <ng-content></ng-content>
</div>
